import React, { useEffect, useState } from "react";
import { Formik, useFormikContext } from "formik";
import { Switch } from "@headlessui/react";
import _ from "lodash";
import { useQuery, gql, useMutation } from "@apollo/client";
// import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import BeneficiarySearchNSelect from "../../../Eligibility/components/requestEligibility/BeneficiarySearchNSelect";
import insurancePlansGQL from "../../../../gql/insurancePlans";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../../../shared/CustomFilterInput";
import { Tooltip } from "@mui/material";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function BeneficiaryInfo({ onChange, refId, setSelectedPatient = () => {} }) {
  const { t, i18n } = useTranslation();
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = useFormikContext();

  const navigate = useNavigate();
  const [insurancePlans, setInsurancePlans] = useState([]);

  const formatInsurancePlansData = (data) => {
    let returnData = [];
    if (data?.length > 0) {
      data.map((item) => {
        returnData.push({
          id: item.id,
          member_card_id: item.member_card_id,
          policy_number: item.policy_number,
          expiry_date: item.expiry_date,
          isPrimary: item.isPrimary,
          payerId: item?.payer?.id,
          relation_with_subscriber: item.relation_with_subscriber,
          coverage_type: item.coverage_type,
          patient_share: item.patient_share,
          maxLimit: item.maxLimit,
          payerNphiesId: item.payerNphiesId,
          patientId: item.patientId,
          name: item?.payer?.name_en,
          license_id: item?.payer?.license_id,
        });
      });
    } else {
    }
    return returnData;
  };

  // const {
  //   loading: loadingPatients,
  //   error: errorPatient,
  //   data: iPlansData,
  //   refetch,
  // } = useQuery(insurancePlansGQL.GET_ALL_INSURANCE_PLANS, {
  //   variables: { limit: 100, page: 1 },
  // });

  // React.useEffect(() => {
  //   if (iPlansData) {
  //     setInsurancePlans(
  //       formatInsurancePlansData(iPlansData.getAllInsurancePlans.data)
  //     );
  //   }
  // }, [iPlansData]);

  const addData = (values) => {
    // setShowEligibilityModal(false);
    let data = _.cloneDeep(values);
    // checkEligibility({ variables: { input: data } });
  };

  const formikRef = React.useRef();
  React.useImperativeHandle(refId, () => ({
    Submit: async () => {
      await formikRef.current.submitForm();
    },
  }));

  const setInsuranceValue = (data, setFieldValue) => {
    for (let i = 0; i < data.length; i++) {
      const element = data[i];

      if (element.isPrimary) {
        setFieldValue("insurancePlanId", element.id);
        setFieldValue("payerId", element.payerId);
        setFieldValue("payerName", element.name);
        setFieldValue("insuransetSelectedPatientcePlanIndex", i);
        break;
      } else {
      }
    }
  };

  useEffect(() => {
    if (insurancePlans && insurancePlans.length > 0) {
      setFieldValue("insurancePlanIndex", 0);
      setFieldValue("insurancePlanId", insurancePlans[0].id);
      setFieldValue("payerId", insurancePlans[0]?.payerId);
      setFieldValue("payerName", insurancePlans[0].name);
    } else {
      setFieldValue("insurancePlanId", "");
      setFieldValue("payerId", "");
      setFieldValue("payerName", "");
    }
  }, [insurancePlans]);

  const SmallToggle = ({ label, checked, onChange, id }) => {
    const isRtl = i18n.language === "ar";

    return (
      <div
        className="flex items-center gap-x-2 cursor-pointer group"
        onClick={onChange}
      >
        <div
          className={`relative inline-flex h-4 w-8 items-center rounded-full transition-colors duration-200 ease-in-out ${
            checked ? "bg-[#0070C2]" : "bg-gray-300"
          }`}
        >
          <span
            className={`inline-block h-3 w-3 transform rounded-full bg-white shadow-sm transition duration-200 ease-in-out ${
              isRtl
                ? checked
                  ? "-translate-x-[18px]"
                  : "-translate-x-[2px]"
                : checked
                  ? "translate-x-[18px]"
                  : "translate-x-[2px]"
            }`}
          />
        </div>
        <span className="text-[10px] font-bold text-gray-600 uppercase tracking-tight select-none">
          {label}
        </span>
      </div>
    );
  };
  const showNewBorn = values.isNewBorn;
  const showInsurance = values.patientId && !values.isFollowUpReq;

  // Count visible inputs
  const activeCols = 1 + (showNewBorn ? 1 : 0) + (showInsurance ? 1 : 0);

  // 6-col grid: 1 item = span 6, 2 items = span 3, 3 items = span 2
  const itemSpan =
    activeCols === 1 ? "span 6" : activeCols === 2 ? "span 3" : "span 2";

  return (
    <>
      <div className="pre_auth_benef_info !gap-2 !mb-0 !p-0 !shadow-none !border-0 !rounded-none flex w-full">
        <div className="flex-shrink-0 md:pt-[5px]">
          <div className="flex items-center gap-x-6 ml-1">
            <SmallToggle
              id="newborn"
              label={t("New Born?")}
              checked={values.isNewBorn}
              onChange={() => setFieldValue("isNewBorn", !values.isNewBorn)}
            />
            <SmallToggle
              id="referral"
              label={t("Referral")}
              checked={values.isReferral}
              onChange={() => setFieldValue("isReferral", !values.isReferral)}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-x-1.5 w-full flex-1 md:ml-4">
          <div className="w-full" style={{ gridColumn: itemSpan }}>
            <div className="flex flex-nowrap items-center gap-1 mt-[6px] overflow-hidden">
              <label
                htmlFor="myInput"
                className="text-[10px] items-center leading-tight uppercase font-semibold text-gray-700 shrink-0 "
              >
                {t("Beneficiary")}
              </label>
              {values.patientName && (
                <div className="min-w-0 flex-1 overflow-hidden">
                  <Tooltip title={values.patientName} arrow>
                    <span
                      className="text-[10px] text-gray-500 cursor-default block"
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      ({values.patientName})
                    </span>
                  </Tooltip>
                </div>
              )}
            </div>
            <BeneficiarySearchNSelect
              setFieldValue={(val) => {
                console.log(setSelectedPatient, val);

                if (values.isNewBorn) {
                  setFieldValue("insurancePlanIndex", "");
                } else {
                  let formattedIPlans = formatInsurancePlansData(
                    val.insurancePlans,
                  );
                  setInsurancePlans(formattedIPlans);

                  setInsuranceValue(formattedIPlans, setFieldValue);
                }
                setFieldValue("patientId", val.id);
                setFieldValue("patientName", val.name);
                setSelectedPatient(val);
              }}
            />
            {errors.patientId && touched.patientId ? (
              <p className="max-w-2xl text-sm leading-6 text-red-500">
                {errors.patientId}
              </p>
            ) : null}
          </div>

          {showNewBorn && (
            <div className="w-full mt-[6px]" style={{ gridColumn: itemSpan }}>
              <div className="flex flex-nowrap items-center gap-1 overflow-hidden">
                <label
                  for="myInput"
                  className="font-semibold text-[11px] text-gray-700 capitalize shrink-0"
                >
                  {t("Subscriber")}
                </label>
                {values.subscriberName && (
                  <div className="min-w-0 flex-1 overflow-hidden">
                    <Tooltip title={values.subscriberName} arrow>
                      <span
                        className="text-[11px] text-gray-500 cursor-default block"
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        ({values.subscriberName})
                      </span>
                    </Tooltip>
                  </div>
                )}
              </div>
              <BeneficiarySearchNSelect
                setFieldValue={(val) => {
                  if (values.isNewBorn) {
                    let formattedIPlans = formatInsurancePlansData(
                      val.insurancePlans,
                    );
                    setInsurancePlans(formattedIPlans);

                    setInsuranceValue(formattedIPlans, setFieldValue);
                  } else {
                  }
                  setFieldValue("subscriber", val.id);
                  setFieldValue("subscriberName", val.name);
                  setSelectedPatient(val);
                }}
              />
            </div>
          )}

          {showInsurance && (
            <div className="w-full" style={{ gridColumn: itemSpan }}>
              <div className="flex flex-nowrap items-center gap-1 mb-0.5 overflow-hidden">
                <label
                  htmlFor="insurancePlanIndex"
                  className="font-semibold text-[11px] text-gray-700 capitalize shrink-0"
                >
                  {t("Insurance Plans")}
                  <span className="text-sm text-red-500"> *</span>
                </label>
                {values.payerName && (
                  <div className="min-w-0 flex-1 overflow-hidden">
                    <Tooltip title={values.payerName} arrow>
                      <span
                        className="text-[11px] text-gray-500 cursor-default block"
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        ({values.payerName})
                      </span>
                    </Tooltip>
                  </div>
                )}
              </div>
              <select
                id="insurancePlanIndex"
                name="insurancePlanIndex"
                onChange={(e) => {
                  let iPlanIndex = e.target.value;
                  setFieldValue("insurancePlanIndex", iPlanIndex);

                  if (iPlanIndex != "") {
                    setFieldValue(
                      "insurancePlanId",
                      insurancePlans[iPlanIndex].id,
                    );

                    setFieldValue(
                      "payerId",
                      insurancePlans[iPlanIndex]?.payerId,
                    );
                    setFieldValue("payerName", insurancePlans[iPlanIndex].name);
                  } else {
                    setFieldValue("insurancePlanId", "");
                    setFieldValue("payerId", "");
                    setFieldValue("payerName", "");
                  }
                }}
                value={values.insurancePlanIndex}
                autoComplete="type-name"
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-cyan-500 focus:ring-cyan-500 sm:text-sm"
              >
                <option value="">{t("Please Select")}</option>
                {insurancePlans.map((item, index) => {
                  return (
                    <option value={index}>
                      <p>
                        {" "}
                        {item?.name} ({item?.member_card_id})
                      </p>
                    </option>
                  );
                })}
              </select>
              {errors.insurancePlanId && touched.insurancePlanId ? (
                <p className="max-w-2xl text-sm leading-6 text-red-500">
                  {errors.insurancePlanId}
                </p>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default BeneficiaryInfo;
